import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ValueListsService } from '@thehubz/client/core';
import { UserInfo } from '@thehubz/client/data-access-api';
import { map, Observable, of } from 'rxjs';
import { SpAvatarService } from './services/sp-avatar.service';

@Component({
  selector: 'sp-avatar',
  templateUrl: './sp-avatar.component.html',
  styleUrls: ['./sp-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpAvatarComponent implements OnInit, OnChanges {
  /**
   * Name text
   */
  @Input() user?: UserInfo | string | any;

  /**
   * Size of avatar
   */
  @Input() size = 50;

  /**
   * Font size of text
   */
  @Input() fontSize = 14;

  /**
   * Image url to be shown in avatar
   */
  @Input() showToolTip = false;

  /**
   * Image url to be shown in avatar
   */
  @Input() externalFlag = false;

  /**
   * annotation class for annotation status
   */
  @Input() annotationClass = '';

  /**
   * image size for blankImage
   */
  @Input() blankImageSize = '';

  /**
   * Name text
   */
  @Input() clickable = true;

  /**
   * Click event on avatar click
   */
  @Output() clickEvent = new EventEmitter<void>();

  userProfileURL?: string;
  userInfo$!: Observable<UserInfo>;

  private userId?: string;

  /**
   * User out of office message
   */
  outOfOfficeMessage = '';
  blankImageFlag = false;
  annotationStatus = '';
  constructor(private spAvatarService: SpAvatarService, private router: Router, private cdr: ChangeDetectorRef, private valueListsService: ValueListsService) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.blankImageFlag = false;
    this.annotationStatus = '';
    if (changes['user'] && changes['user']['currentValue']) {
      if (changes['user']['currentValue'] && !changes['user']['currentValue']['name'] && typeof changes['user']['currentValue'] != 'string') {
        this.blankImageFlag = true;
      }
      if (changes['user']['currentValue']['submitted']) {
        this.annotationStatus = 'submitted';
      } else if (changes['user']['currentValue']['annotated']) {
        this.annotationStatus = 'annotated';
      } else if (changes['user']['currentValue']['opened']) {
        this.annotationStatus = 'opened';
      }
      this.userInfo$ = this.spAvatarService.lookupUserInfo$(changes['user']['currentValue']);
      if (!this.externalFlag) {
        this.userProfileURL = this.spAvatarService.getImagedUrl(changes['user']['currentValue']['id']);
      }
    }
  }

  ngOnInit(): void {
    if (this.user && !this.externalFlag) {
      this.userId = this.spAvatarService.lookupUserId(this.user);
      this.userInfo$ = this.spAvatarService.lookupUserInfo$(this.user);
      // the team has ._id not .id
      this.userProfileURL = this.spAvatarService.getImagedUrl(this.userId);
      if (this.userId) {
        this._isUserOnVacation(this.userId);
      }
    }
  }

  onClick() {
    if (this.externalFlag) {
      return;
    }
    if (this.userId && this.clickable) {
      this.router.navigate(['user', 'profile'], { queryParams: { userId: this.userId } });
    }
    this.clickEvent.emit();
  }

  imgLoadError() {
    this.spAvatarService.userHasNoImage(this.userId);
    this.userProfileURL = undefined;
  }

  tooltip$() {
    if (this.outOfOfficeMessage) {
      return of(this.outOfOfficeMessage);
    }
    if (this.showToolTip) {
      return this.userInfo$.pipe(map((userInfo) => (userInfo.name ? userInfo.name : userInfo.email)));
    }
    return of('');
  }

  /**
   * Check if the user is on vacation today
   * @param userId
   */
  private _isUserOnVacation(userId: string) {
    this.valueListsService.lookupUserInfo(userId)?.subscribe((user) => {
      if (user && user.vacation) {
        this.outOfOfficeMessage = user.outOfOfficeMessage ?? '';
        this.cdr.markForCheck();
      }
    });
  }
}
